<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink class="d-flex justify-items-center">
        <ImageProfile size="sm5" sizeFontAvatar="13px" />
        <i class="fas fa-chevron-down font-xs ml-2 font-weight-normal"></i>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="chooseSettingsRoute">
      {{ $t('sender.domainSender.domainSenderList.status.settings') }}
    </CDropdownItem>
    <!-- <CDropdownItem>
      Billing
    </CDropdownItem>
    <CDropdownItem>
      Notification
    </CDropdownItem> -->
    <CDropdownItem :to="{ name: 'help' }">
      {{ $t('general.header.navs.settings.help') }}
    </CDropdownItem>
    <CDropdownItem @click="logout()">
      {{ $t('sender.domainSender.domainSenderList.status.logout') }}
    </CDropdownItem>
  </CDropdown>
</template>
<script>
import services from '../services/services'
import ImageProfile from '@/components/ImageProfile.vue'

export default {
  name: 'TheHeaderDropdownAccnt',
  components: { ImageProfile },
  mounted() {
    // TODO Sugestão: Colocar sempre apenas o primeiro e último nome do utilizador
    // Coloca sempre o primeiro e ultimo nomo do utilizador
    var array = this.$store.state.auth.user.name && this.$store.state.auth.user.name.split(' ')
    if (array.length) {
      this.userName = array[0] + (array.length >= 2 ? ' ' + array[array.length - 1] : '')
    } else {
      this.userName = array[0]
    }
  },
  data() {
    return {
      itemsCount: 42,
      userName: this.$store.state.auth.user.name,
    }
  },
  methods: {
    chooseSettingsRoute() {
      if (!this.$route.params.organizationId) {
        this.$router.push({ name: 'basic-info-default' })
      } else {
        this.$router.push({ name: 'basic-info' })
      }
    },
    logout() {
      var UserId = this.$store.state.auth.user.id
      services.logout(UserId).then(() => {
        this.$store.dispatch('auth/logout')
      })
    },
  },
}
</script>
<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
